export enum AmountModel {
	AmountMonthly = 'AMOUNT_MONTHLY',
	AmountAverageLastThreeMonths = 'AMOUNT_AVERAGE_LAST_THREE_MONTHS',
	AmountAverageLastTwelveMonths = 'AMOUNT_AVERAGE_LAST_TWELVE_MONTHS',
	MultipleModels = 'MULTIPLE_MODELS',
}
